import { createFileRoute } from '@tanstack/react-router'
import { DocumentsSettings } from '@/features/settings/documents-settings'

export const Route = createFileRoute('/_layout/_app/settings/documents/')({
  component: () => <DocumentsSettings folderPath="" />,
})
